import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const AccessibilityContext = createContext(null);
export const useA11y = () => useContext(AccessibilityContext);

const DEFAULTS = { low_stim: false, dyslexia_font: false, text_scale: 1, theme: 'light' };

function apply(prefs) {
  const html = document.documentElement;
  const body = document.body;
  html.classList.toggle('low-stim', !!prefs.low_stim);
  html.classList.toggle('dark', prefs.theme === 'dark');
  body.classList.toggle('font-dyslexia', !!prefs.dyslexia_font);
  html.style.setProperty('--text-scale', String(prefs.text_scale || 1));
}

export function AccessibilityProvider({ children }) {
  const [prefs, setPrefs] = useState(() => {
    try {
      const raw = localStorage.getItem('tempo_a11y');
      return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : DEFAULTS;
    } catch (e) { return DEFAULTS; }
  });

  useEffect(() => { apply(prefs); }, [prefs]);

  const update = useCallback((partial) => {
    setPrefs((p) => {
      const next = { ...p, ...partial };
      try { localStorage.setItem('tempo_a11y', JSON.stringify(next)); } catch (e) {}
      apply(next);
      return next;
    });
  }, []);

  return (
    <AccessibilityContext.Provider value={{ prefs, update }}>
      {children}
    </AccessibilityContext.Provider>
  );
}
